import * as React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styles from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel.module.scss';
import Moment from 'react-moment';

const CollectionDetails = translate()(({ t, asset }) => {
  return (
    <div className={`${styles['list-container']} collection-details`}>
      <b>{t('general:labels.collection_details')}</b>
      <ul>
        <li>
          {t('general:assets.labels.date_available_for_collection')}:{' '}
          <Moment date={asset.collection_date} format="MMMM DD, YYYY" />
        </li>
        <li>
          {t('general:labels.address_details')}: {asset.collection_location}
        </li>
        <li>
          {t('general:labels.contact_name')}: {asset.collection_contact}
        </li>
        <li>
          {t('general:labels.contact_email')}: {asset.collection_email}
        </li>
      </ul>
    </div>
  );
});

CollectionDetails.propTypes = {
  asset: PropTypes.object.isRequired,
};

export default CollectionDetails;
